import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

// When the sidebar is open, give the link enough room to fit the
// Pyrana icon + wordmark (the default `drawerWidthClosed` clips the
// "Pyrana" text). When collapsed, fall back to the narrow width so the
// icon stays centered in the collapsed drawer.
const useSidebarLogoStyles = makeStyles<unknown, { isOpen: boolean }>({
  root: {
    width: ({ isOpen }) =>
      isOpen ? sidebarConfig.drawerWidthOpen : sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: ({ isOpen }) =>
      isOpen ? sidebarConfig.drawerWidthOpen - 24 : sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

export const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();
  const classes = useSidebarLogoStyles({ isOpen });

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
